import React from 'react';
import { contactItems, socialMediaItems, symbolItems } from './footerData.js';
import { Tooltip } from '@mui/material';

const Footer = () => {
    return (
        <footer className="footer bg-primary w-full text-white">
            <div className="w-full px-8 sm:px-0 xl:px-12 pt-14 pb-6">
                <div className="inner-footer container mx-auto">
                    <div className="flex flex-col md:flex-row items-center">
                        <div className="flex-1 mb-14 md:mx-10">
                            <div className="mb-2">
                                <img
                                    src="/assets/Pics/logo.svg"
                                    alt="WISERCAM"
                                    className="w-56 lg:w-52"
                                />
                            </div>
                            <div className="flex flex-col ps-1">
                                {contactItems.map((item, index) => (
                                    <div key={`${Math.random()}_${index}`}
                                        className="flex items-center my-2">
                                        <span className="me-2">
                                            {item.icon()}
                                        </span>
                                        {item.text}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="flex-1 md:mx-10 mb-10 text-center">
                            <h3 className="text-xl mb-4">لینک شبکه‌های اجتماعی</h3>
                            <div className="flex items-center justify-center gap-4 mb-5">
                                {socialMediaItems.map((item, index) => (
                                    <a
                                        key={`social_media_${index}`}
                                        href={item.href} title={item.title}
                                        target="_blank" rel="noreferrer"
                                        className="scalable w-10
                                        flex justify-center items-center"
                                    >
                                        {item.icon()}
                                    </a>
                                ))}
                            </div>
                            {/* <div className="flex items-center justify-center">
                                {symbolItems.map((item, index) => (
                                    <Tooltip
                                        key={`symbol_${index}`}
                                        title={item.title}
                                        arrow={true}
                                        placement="bottom"
                                    >
                                        <div
                                            className="bg-white 
                                        border border-gray-700
                                        rounded-lg mx-2
                                        w-24 h-24 md:w-32 md:h-32 
                                        flex justify-center
                                        items-center overflow-hidden">
                                            {item.link ? (
                                                <a
                                                    href={item.link}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="w-full h-full flex justify-center items-center"
                                                >
                                                    <img
                                                        src={item.src}
                                                        alt={item.title}
                                                        className="w-10/12"
                                                    />
                                                </a>
                                            ) : (
                                                <img
                                                    src={item.src}
                                                    alt={item.title}
                                                    className="w-10/12"
                                                />
                                            )}
                                        </div>
                                    </Tooltip>
                                ))}
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="h-16 flex justify-center
             items-center bg-blue-900">
                <svg width="24" height="24" viewBox="0 0 28 28" fill="none"
                    className="me-2"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M14 0.5C11.33 0.5 8.71987 1.29176 6.49981 2.77516C4.27974 4.25856 2.54942 6.36697 1.52763 8.83377C0.505849 11.3006 0.238504 14.015 0.759405 16.6337C1.28031 19.2525 2.56606 21.6579 4.45406 23.5459C6.34207 25.434 8.74754 26.7197 11.3663 27.2406C13.985 27.7615 16.6994 27.4942 19.1662 26.4724C21.633 25.4506 23.7414 23.7203 25.2248 21.5002C26.7082 19.2801 27.5 16.67 27.5 14C27.496 10.4208 26.0724 6.98932 23.5416 4.45844C21.0107 1.92756 17.5792 0.50397 14 0.5ZM14 24.5C11.9233 24.5 9.89324 23.8842 8.16652 22.7304C6.4398 21.5767 5.09399 19.9368 4.29927 18.0182C3.50455 16.0996 3.29662 13.9884 3.70176 11.9516C4.10691 9.91475 5.10693 8.04383 6.57538 6.57538C8.04384 5.10693 9.91476 4.1069 11.9516 3.70175C13.9884 3.29661 16.0996 3.50454 18.0182 4.29926C19.9368 5.09399 21.5767 6.4398 22.7304 8.16651C23.8842 9.89323 24.5 11.9233 24.5 14C24.497 16.7839 23.3898 19.4528 21.4213 21.4213C19.4529 23.3898 16.7839 24.497 14 24.5ZM19.1988 17.9013C18.3799 18.9922 17.2387 19.7979 15.9366 20.2042C14.6345 20.6106 13.2375 20.597 11.9436 20.1654C10.6496 19.7339 9.52421 18.9062 8.72675 17.7995C7.92928 16.6929 7.50016 15.3634 7.50016 13.9994C7.50016 12.6353 7.92928 11.3059 8.72675 10.1992C9.52421 9.0926 10.6496 8.26488 11.9436 7.8333C13.2375 7.40172 14.6345 7.38815 15.9366 7.79451C17.2387 8.20087 18.3799 9.00657 19.1988 10.0975C19.3214 10.2546 19.4115 10.4345 19.4638 10.6268C19.5161 10.8191 19.5296 11.0199 19.5035 11.2175C19.4773 11.415 19.412 11.6054 19.3115 11.7774C19.2109 11.9495 19.0771 12.0998 18.9178 12.2195C18.7585 12.3393 18.577 12.4261 18.3838 12.4749C18.1906 12.5237 17.9896 12.5335 17.7925 12.5038C17.5955 12.474 17.4063 12.4053 17.2361 12.3017C17.0659 12.198 16.9181 12.0614 16.8013 11.9C16.3605 11.3123 15.746 10.8782 15.0448 10.6592C14.3437 10.4402 13.5914 10.4473 12.8945 10.6796C12.1976 10.9119 11.5914 11.3576 11.1619 11.9535C10.7324 12.5494 10.5013 13.2654 10.5013 14C10.5013 14.7346 10.7324 15.4506 11.1619 16.0465C11.5914 16.6424 12.1976 17.0881 12.8945 17.3204C13.5914 17.5527 14.3437 17.5598 15.0448 17.3408C15.746 17.1218 16.3605 16.6877 16.8013 16.1C16.9171 15.9362 17.0646 15.7973 17.2351 15.6915C17.4055 15.5857 17.5955 15.5152 17.7937 15.4841C17.9919 15.4531 18.1943 15.4621 18.389 15.5106C18.5837 15.5592 18.7666 15.6463 18.927 15.7668C19.0874 15.8873 19.222 16.0387 19.3228 16.2122C19.4236 16.3856 19.4887 16.5776 19.514 16.7766C19.5393 16.9756 19.5245 17.1777 19.4703 17.3709C19.4162 17.564 19.3238 17.7444 19.1988 17.9013Z"
                        fill="#EAEAEA" />
                </svg>
                تمامی حقوق برای وبسایت wisercam محفوظ است.
            </div>
        </footer>
    );
}

export default Footer;
